import { makeStyles } from 'tss-react/mui';

const styles = makeStyles({ name: 'Callout' })((theme) => ({
  root: {
    margin: theme.spacing(2, 0),
    padding: theme.spacing(2),
    paddingLeft: theme.spacing(3),
    height: '100%',
    width: '100%',
    maxWidth: '750px',
    backgroundColor: theme.palette.custom.blue.light,
    borderLeft: `4px solid ${theme.palette.primary.main}`,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
    [theme.breakpoints.down('lg')]: {
      paddingLeft: theme.spacing(1),
    },
  },
  icon: {
    color: theme.palette.primary.main,
    flexShrink: 0,
  },
  text: {
    marginLeft: theme.spacing(2),
  },
}));

export default styles;
